import { render } from "./BlogShow.vue?vue&type=template&id=f8c77e56"
import script from "./BlogShow.vue?vue&type=script&lang=js"
export * from "./BlogShow.vue?vue&type=script&lang=js"

import "./BlogShow.vue?vue&type=style&index=0&id=f8c77e56&lang=css"

import exportComponent from "/home/kira/codemark/zonadigital/frond/deploy/zona-digital-ecommerce-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__